import blog from "../assets/projects/blog.png";
import movie from "../assets/projects/movie-app.png";
import snapp from "../assets/projects/snapp-site.png";
import todo from "../assets/projects/todoApp-react.png";
import mobile from "../assets/projects/mobile-shop.png";
import todoJS from "../assets/projects/todoApp-JS.png";
import adminPanel from "../assets/projects/adminPanel.png";
import weatherApp from "../assets/projects/weatherApp.png";
import guessNumber from "../assets/projects/guessNumber.png";

export const data = [
  {
    id: 1,
    name: "admin-dashboard (react)",
    image: adminPanel,
    github: "https://github.com/mahdirez/admin-dashboard",
    live: "https://admin-dashboard-pi-three.vercel.app",
  },
  {
    id: 2,
    name: "mobile shop (react)",
    image: mobile,
    github: "https://github.com/mahdirez/mobile-shop",
    live: "https://mobile-shop101102.netlify.app",
  },
  {
    id: 3,
    name: "movie app (react)",
    image: movie,
    github: "https://github.com/mahdirez/movie-app",
    live: "https://movie-app-react-rezaei.netlify.app",
  },
  {
    id: 4,
    name: "todo app (React)",
    image: todo,
    github: "https://github.com/mahdirez/todoApp-react",
    live: "https://todoapp-react-js-mahdi-rezaei.netlify.app",
  },
  {
    id: 5,
    name: "weblog (html,css)",
    image: blog,
    github: "https://github.com/mahdirez/weblog",
    live: "https://weblogmahdirezaei.netlify.app",
  },
  {
    id: 6,
    name: "Guess the Number (JS)",
    image: guessNumber,
    github: "https://github.com/mahdirez/GuessTheNumber-JS",
    live: "https://guessthenumber-rezaei.netlify.app",
  },
  {
    id: 5,
    name: "snapp Application (html,css)",
    image: snapp,
    github: "https://github.com/mahdirez/snapp",
    live: "https://snappwebpagerezaei.netlify.app",
  },
  {
    id: 8,
    name: "todo app (JS)",
    image: todoJS,
    github: "https://github.com/mahdirez/Todolist-JS",
    live: "https://todolist-rezaei.netlify.app",
  },
  {
    id: 9,
    name: "weather app (React)",
    image: weatherApp,
    github: "https://github.com/mahdirez/weatherApp-React",
  },
];
